exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-div, .checkbox-div * {\r\n    cursor: pointer;\r\n}\r\n\r\n.checkbox-div {\r\n    margin: .4em;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\ninput[type=\"checkbox\"] {\r\n    width: 1.25em;\r\n    height: 1.25em;\r\n    margin: .5em;\r\n}\r\n\r\ninput[type=\"checkbox\"], input[type=\"checkbox\"] + label {\r\n    margin: 0.25em;\r\n}\r\n", ""]);

// exports
